
<template>
    <div>
        <b-button variant="primary" class="mr-2" @click="excelExport()">
            <i class="ri-file-excel-2-line mr-2"></i> {{ label }}
        </b-button>
    </div>
</template>

<script>
import SystemService from "@/services/SystemService";

export default{
    props:{
        label:{
            type: String,
            default:"Excel"
        },
        data:{
            default:null
        },
        headings:{
            default:null
        },
        fileName:{
            type: String,
            default: "export"
        },
    },
    methods: {
        excelExport() {
            let formData = {
                data: this.data,
                headings: this.headings,
                fileName: this.fileName
            };
            SystemService.excelExport(formData).then(response=>{
                this._downloadFile(response, this.fileName + '.xlsx');
            });
        },
    },
}
</script>
